<section mat-dialog-title>
  <span>Change password</span>
  <button mat-dialog-close>
    <i class="icon-close"></i>
  </button>
</section>
@if (form) {
  <form
    (ngSubmit)="saveChanges()"
    [formGroup]="form"
    >
    <mat-dialog-content>
      <div class="flex flex-col lg:flex-row">
        <label
          class="input-main-label"
          for="new-password"
        >New password</label>
        <mat-form-field
          class="input-main w-full lg:w-[404px]"
          appearance="outline"
          >
          <input
            id="new-password"
            [type]="hideInput.password ? 'password' : 'text'"
            formControlName="password"
            matInput
            />
          <i
            class="text-ui-dark cursor-pointer text-3xl mr-2"
            (click)="hideInput.password = !hideInput.password"
            [class]="hideInput.password ? 'icon-eye-open' : 'icon-eye-close'"
            matSuffix
          ></i>
          <mat-error>Form is not valid</mat-error>
        </mat-form-field>
      </div>
      <div class="flex flex-col lg:flex-row">
        <label
          class="input-main-label"
          for="new-password-repeat"
        >Confirm new password</label>
        <mat-form-field
          class="input-main w-full lg:w-[404px]"
          appearance="outline"
          >
          <input
            id="new-password-repeat"
            [type]="hideInput.confirmPassword ? 'password' : 'text'"
            formControlName="confirmPassword"
            matInput
            />
          <i
            class="text-ui-dark cursor-pointer text-3xl mr-2"
            (click)="hideInput.confirmPassword = !hideInput.confirmPassword"
            [class]="hideInput.confirmPassword ? 'icon-eye-open' : 'icon-eye-close'"
            matSuffix
          ></i>
          <mat-error>
            {{
            form.controls['confirmPassword'].errors?.['confirmedValidator']
            ? 'Passwords mismatch'
            : 'Form is not valid'
            }}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="lg:ml-auto lg:w-[404px]">
        <app-password-requirements
          [isDarkMode]="true"
          [password]="form.controls['password'].value"
          />
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button
        class="test-btn-cancel btn-transparent btn-medium font-bold mr-4"
        mat-dialog-close
      >CANCEL</button>
      <button
        type="submit"
        class="btn-green btn-medium font-bold"
        (click)="saveChanges()"
        [disabled]="(isLoading$ | async) === true"
        >
        @if ((isLoading$ | async) === true) {
          <mat-spinner
            class="mr-1"
            diameter="20"
          ></mat-spinner>
        }
        SAVE
      </button>
    </mat-dialog-actions>
  </form>
}
